import { render, staticRenderFns } from "./modal-stop-trade-idea.component.vue?vue&type=template&id=9968ceec&scoped=true"
import script from "./modal-stop-trade-idea.component.vue?vue&type=script&lang=js"
export * from "./modal-stop-trade-idea.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9968ceec",
  null
  
)

export default component.exports